import { NgModule } from '@angular/core';
import {
  DisableClickEventDirective
} from '~app/modules/storyblok/directives/disable-click-event/disable-click-event.directive';

@NgModule({
  exports: [DisableClickEventDirective],
  declarations: [DisableClickEventDirective],
})
export class DisableClickEventModule {
}
